module.exports = __webpack_public_path__ + "img/create-referral-purple.6de1c595.svg";